import { ScrollSpy } from 'bootstrap/dist/js/bootstrap.esm.min'

Array.from( document.querySelectorAll( '.wp-toolkit .scrollspy' ) )
     .forEach( scrollspyNode => new ScrollSpy( scrollspyNode ) )
